import Button from '../../../button/button';
import UserAddSVG from '../../../icons/userAdd'
import './Academic.scss'
import TableCstm from '../../..//TableCstm/TableCstm';
import { useEffect, useState, useMemo } from 'react';
import { GetStudentListClassesByStudent, PostWithdrawStudent } from '../../../../utils/Apis/apis';
import { useNavigate } from "react-router-dom";
import EnrollGroupModal from './StudentEnrollClass/EnrollGroup';
import Alert from '../../../alert/Alert';
import Tooltip from '../../../Tooltip/Tooltip';
import ChangeArrowsSVG from '../../../icons/changeArrows';
import DownArrowSVG from '../../../icons/downArrow';
import ConfirmModal from '../../../ConfirmModalV3/confirmModal';
import ChangeStudentGroup from './ChangeStudentGroup';
import PasswordAlert from '../../../passwordAlert/passwordAlert';
import { PostReceptionistInCharge } from '../../../../utils/Apis/apis';
import UserRemoveSVG from '../../../icons/userRemove'
import { PostDefinitiveWithdrawStudent } from '../../../../utils/Apis/receptionApis';
import { formatTime } from '../../../../utils/format';
import PauseDropStudentCalendar from './PauseDropStudentCalendar/PauseDropStudentCalendar';
const Academic = ({ listClasses, studentSelected, classCache, subsidiaryList }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isEnrollOpen, setIsEnrollOpen] = useState(false);
    const [classData, setClassData] = useState([])
    const [availableClasses, setAvailableClasses] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isChangeStudentOpen, setIsChangeStudentOpen] = useState(false);
    const [isPasswordRequired, setIsPasswordRequired] = useState(false);
    const [confirmDropOut, setConfirmDropOut] = useState(false)
    const [openPauseDropSCalendarModal, setOpenPauseDropSCalendarModal] = useState(false)
    //ALERT
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);
    const [arrayAlerts, setArrayAlerts] = useState([])
    const [action, setAction] = useState('')

    const [modalHandlers, setModalHandlers] = useState({
        handleAcceptPassword: () => { },
        handleCancelPassword: () => { },
    });
    useEffect(() => {
        const studentId = studentSelected?.student?.id;
        if (!studentId) return;
        const key = String(studentId);
        if (classCache.current[key]) {
            setClassData(classCache.current[key]);
            return;
        }

        const controller = new AbortController();

        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await GetStudentListClassesByStudent(studentId);
                if (controller.signal.aborted) return;

                if (response.auth === false) {
                    navigate("/login");
                    return;
                }

                const studentClassesArray = response.result.class_info;
                const formatted = studentClassesArray.map(c => ({
                    id: c.id,
                    label: `${c.teacher || 'Maestro no asignado'} / ${c.level.name} / ${formatDays(c.day)} ${formatTime(c.time_start)} - ${formatTime(c.time_end)}`,
                    subsidiary: c.subsidiary.name,
                    subsidiaryId: c.subsidiary.id,
                    isOnline: c.is_online ? "En línea" : "Presencial",
                    class_type: ClassTypeName(c.class_type),
                    raw_class_type: c.class_type,
                    student_date_registered: c.date?.student_date_registered || '',
                    student_date_withdraw: c.date?.student_date_withdraw || '',
                    st: c.st,
                }));
                classCache.current[key] = formatted; // Guardamos con clave string
                setClassData(formatted);

            } catch (err) {
                if (!controller.signal.aborted) {
                    setError("Error al cargar los grupos");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };
        fetchData();

        return () => controller.abort();
    }, [studentSelected?.student?.id]);

    useEffect(() => {
        if (!listClasses || !classData) return;

        // Obtener los IDs de las clases con st === 0 y
        const studentClassIds = classData
            .filter(c => c.st !== 0)
            .map(c => c.id);
        // Filtrar clases disponibles (que no estén en los IDs anteriores y que tengan tipo de clase)
        const availableClasses = listClasses.filter(
            c => !studentClassIds.includes(c.value) && c.detail_class?.type_class
        );

        setAvailableClasses(availableClasses);
    }, [listClasses, classData]);

    const ClassTypeName = (value) => {
        switch (value) {
            case 1: return ('Clase de inglés');
            case 2: return ('Club de lectura y escritura');
            case 3: return ('Club de conversación');
            default: return ('');
        }
    }

    const formatDays = (daysString) => {
        const dayOrder = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
        const days = daysString.split(", ").map(day => day.trim());

        // Ordenar los días según el orden real de la semana
        const sortedDays = days
            .map(day => ({ day, index: dayOrder.indexOf(day) }))
            .sort((a, b) => a.index - b.index)
            .map(obj => obj.day);

        // Agrupar consecutivos
        const ranges = [];
        let start = sortedDays[0];
        let prevIndex = dayOrder.indexOf(start);

        for (let i = 1; i < sortedDays.length; i++) {
            const currentDay = sortedDays[i];
            const currentIndex = dayOrder.indexOf(currentDay);

            if (currentIndex === prevIndex + 1) {
                // aún es consecutivo
                prevIndex = currentIndex;
            } else {
                // fin de un rango
                if (start !== sortedDays[i - 1]) {
                    ranges.push(`${start}-${sortedDays[i - 1]}`);
                } else {
                    ranges.push(start);
                }
                start = currentDay;
                prevIndex = currentIndex;
            }
        }

        // último rango
        if (start !== sortedDays[sortedDays.length - 1]) {
            ranges.push(`${start}-${sortedDays[sortedDays.length - 1]}`);
        } else {
            ranges.push(start);
        }

        return ranges.join(" y ");
    };

    const classColumns = [
        { header: "ID Grupo", accessor: "id" },
        { header: "Grupo(s)", accessor: "label" },
        { header: "Sucursal", accessor: "subsidiary" },
        { header: "Modalidad", accessor: "isOnline" },
        { header: "Tipo de clase", accessor: "class_type" },
        { header: "Fecha de ingreso", accessor: "student_date_registered" },
        { header: "Fecha de baja", accessor: "student_date_withdraw" },
        { header: "Acciones", accessor: "actions" },

    ];
    const handleEnrollOpen = () => {
        setIsEnrollOpen(true);
    }
    const handleEnrollClose = () => {
        setIsEnrollOpen(false);
    }
    // Función auxiliar para mostrar alertas
    const showAlert = (type, message) => {
        const id = Math.floor(Math.random() * 100) + 1;
        const alertObj = { id, type, message };

        setArrayAlerts(oldArray => [alertObj, ...oldArray]);
        setIsVisibleAlert(true);
    };

    const refreshClassData = async () => {
        const studentId = studentSelected?.student?.id;
        if (!studentId) return;

        // 🔥 IMPORTANTÍSIMO: limpiar cache previo
        delete classCache.current[String(studentId)];

        setLoading(true);
        setError(null);

        try {
            const response = await GetStudentListClassesByStudent(studentId);
            if (response.auth === false) {
                navigate("/login");
                return;
            }

            const studentClassesArray = response.result.class_info;

            // ✅ SOLO DATOS
            const formatted = studentClassesArray.map(c => ({
                id: c.id,
                label: `${c.teacher || 'Maestro no asignado'} / ${c.level.name} / ${formatDays(c.day)} ${formatTime(c.time_start)} - ${formatTime(c.time_end)}`,
                subsidiary: c.subsidiary.name,
                subsidiaryId: c.subsidiary.id,
                isOnline: c.is_online ? "En línea" : "Presencial",
                class_type: ClassTypeName(c.class_type),
                raw_class_type: c.class_type,
                student_date_registered: c.date?.student_date_registered || '',
                student_date_withdraw: c.date?.student_date_withdraw || '',
                st: c.st,
            }));

            // ✅ cache limpio y sano
            classCache.current[String(studentId)] = formatted;

            // ✅ estado solo con datos
            setClassData(formatted);

            showAlert("success", "Datos actualizados correctamente");
        } catch (err) {
            setError("Error al actualizar los grupos");
            showAlert("danger", "Error al actualizar los grupos");
        } finally {
            setLoading(false);
        }
    };


    const handleOpenChangeStudent = (groupId) => {
        setSelectedGroup(groupId);
        setIsChangeStudentOpen(true);
    }
    const handleClickDropStudentFromGroup = (groupId) => {
        //acciones de baja
        setSelectedGroup(groupId)
        setConfirmDropOut(true)

    }
    const handleCloseDropStudentFromGroup = () => {
        setConfirmDropOut(false);
    }

    const handleConfirmDropStudentFromGroup = async () => {
        let confirmPassword = await ConfirmActionPassword()
        const isAllow = confirmPassword.status
        if (isAllow) {
            setAction('wd')
            setOpenPauseDropSCalendarModal(true)

        }
    }

    const ConfirmActionPassword = () => {
        return new Promise((resolve) => {
            setIsPasswordRequired(true); // Abre el modal

            // Pasas estas funciones al modal para controlar los botones
            const handleAcceptPassword = (formValues) => {
                if (formValues.employee_id !== '' && formValues.password !== '') {
                    const responseToConfirmation = PostReceptionistInCharge(formValues)
                    responseToConfirmation.then((value) => {
                        let status = value.status
                        if (value.hasOwnProperty("auth")) {
                            status = 202
                        }
                        switch (status) {
                            case 200:
                                setIsPasswordRequired(false); // Cierra el modal
                                resolve({ status: true, message: "Edicion Permitida" }); // Resuelve la promesa con "true" si acepta
                                break;
                            case 201:
                                showAlert('info', "Credenciales rechazadas para realizar la edición.")

                                break;
                            case 202:
                                showAlert('info', "Credenciales expiradas")
                                break;
                            default:
                                break;
                        }

                    })
                } else {
                    showAlert('danger', 'Ingrese el correo y la contraseña para verificar sus credenciales.')
                }
            };

            const handleCancelPassword = () => {
                setIsPasswordRequired(false); // Cierra el modal
                resolve({ status: false, message: "Operacion cancelada." }); // Resuelve la promesa con "false" si cancela
            };

            // Almacenar funciones en el estado para pasar al modal
            setModalHandlers({ handleAcceptPassword, handleCancelPassword });
        });
    };


    const handleCloseChangeStudent = () => {
        setIsChangeStudentOpen(false)
    }
    const handleDropOutStudent = async () => {
        let confirmPassword = await ConfirmActionPassword()
        const isAllow = confirmPassword.status
        if (isAllow) {
            setAction('dropOut')
            setOpenPauseDropSCalendarModal(true)

        } else {
            showAlert('danger', confirmPassword.message)
        }
    }
    const handlePauseStudentPayment = async () => {
        let confirmPassword = await ConfirmActionPassword()
        const isAllow = confirmPassword.status
        if (isAllow) {
            setAction('pause')
            setOpenPauseDropSCalendarModal(true)

        } else {
            showAlert('danger', confirmPassword.message)
        }
    }

    const tableData = useMemo(() => {
        return classData.map(row => ({
            ...row,
            actions: (
                <div className='group-act-buttons'>
                    <Tooltip text="Cambio de grupo" position="left">
                        <Button
                            Icon={ChangeArrowsSVG}
                            backgroundColor="transparent"
                            disabled={row.st === 0}
                            onClick={() =>
                                handleOpenChangeStudent({
                                    id: row.id,
                                    subsidiary: row.subsidiaryId,
                                    class_type: row.raw_class_type,
                                })
                            }
                        />
                    </Tooltip>

                    <Tooltip text="Baja en grupo" position="left">
                        <Button
                            Icon={DownArrowSVG}
                            backgroundColor="transparent"
                            disabled={row.st === 0}
                            onClick={() => handleClickDropStudentFromGroup(row.id)}
                        />
                    </Tooltip>
                </div>
            ),
        }));
    }, [classData]);

    return (
        <>
            <div className="academic-data">
                <div className='data-groups section'>
                    <h1 className='title'>Grupos que pertenece</h1>
                    {
                        classData.length > 0 ?
                            <TableCstm
                                columns={classColumns}
                                data={tableData}
                                classN="striped"
                            />
                            :
                            <div className='data-groups-txt'> <p className='striped'>No pertenece a ningun grupo</p></div>
                    }
                    <div className='groups-buttons'>
                        <Button
                            text="Inscribir a grupo"
                            backgroundColor='blue'
                            // disabled="disabled"
                            onClick={handleEnrollOpen}
                            Icon={UserAddSVG}
                        />
                        {
                            studentSelected.st === 1 &&
                            <>
                                <Tooltip text={'Realizar baja de alumno en todas sus clases'}><Button text={'Baja del alumno'} onClick={handleDropOutStudent} Icon={UserRemoveSVG}></Button></Tooltip>
                                <Tooltip text={'Pausar pagos de colegiatura semanal del alumno'}><Button text={'Pausar pagos'} onClick={handlePauseStudentPayment} Icon={UserRemoveSVG}></Button></Tooltip>
                            </>
                        }
                    </div>
                </div>
            </div >
            {isEnrollOpen && <EnrollGroupModal
                isOpen={isEnrollOpen}
                onClose={handleEnrollClose}
                classes={availableClasses}
                subsidiaryList={subsidiaryList}
                studentId={studentSelected?.student?.id}
                showAlert={showAlert}
                refreshData={refreshClassData}
                student_st={studentSelected.st}
            />
            }
            {/* Drop out Modal */}
            {
                isChangeStudentOpen && <ChangeStudentGroup
                    isOpen={isChangeStudentOpen}
                    handleCancel={handleCloseChangeStudent}
                    selectedGroup={selectedGroup}
                    subsidiaryList={subsidiaryList}
                    studentId={studentSelected?.student?.id}
                    showAlert={showAlert}
                    refreshData={refreshClassData}
                />
            }
            {/* Modal Alert */}
            {
                confirmDropOut && <ConfirmModal
                    isOpen={confirmDropOut}
                    handleCancel={handleCloseDropStudentFromGroup}
                    handleAccept={handleConfirmDropStudentFromGroup}
                    title={'Confirme acción'}
                    text={'¿Esta seguro que desea dar de baja al alumno del grupo?'}
                />
            }
            {/* Password required */}
            {
                isPasswordRequired && <PasswordAlert
                    isOpen={isPasswordRequired}
                    handleAccept={modalHandlers.handleAcceptPassword}
                    handleCancel={modalHandlers.handleCancelPassword}
                    title="Confirmar con contraseña"
                />
            }
            <PauseDropStudentCalendar isOpen={openPauseDropSCalendarModal} setOpen={setOpenPauseDropSCalendarModal} student_id={studentSelected.student.id} selectedGroup={selectedGroup} refreshClassData={refreshClassData} showAlert={showAlert} action={action} handleCloseDropStudentFromGroup={handleCloseDropStudentFromGroup} />

            <div className="divAlert">
                <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
            </div>
        </>
    )
}
export default Academic
